import classNames from 'classnames';
import s from './index.module.css';
import { IcoRemove } from '../../../../../../utils/icons';

const UserBlock = ({
    user,
    deleteUser = false,
    onClickByUser = () => {},
}) => {
    return (<div className={s.children}>
        <div 
            onClick={()=>onClickByUser(user)}
            className={classNames(s.childrenBlock, s.childrenName)}>
            { user.name }
        </div>
        {
            !!user.phone && (
                <div className={classNames(s.childrenBlock, s.childrenPhone)}>
                    { user.phone }
                </div>
            )
        }
        {
            !!deleteUser && (
                <div>
                    <div
                        className={s.deleteButton}
                        onClick={() => deleteUser(user.id)}
                    >
                        <IcoRemove />
                    </div>
                </div>
            )
        }
        
    </div>)
}

export default UserBlock;